/* eslint-disable import/prefer-default-export */

/**
 * Translates known backend error codes to user-friendly messages.
 * Matches error codes exactly (case-insensitive) and falls back to the original error message if no match is found.
 * @param baseError - The raw error message from the API response
 * @param code - The error code from the API response (e.g., 'EFLD021', 'EEXT001')
 * @returns Translated user-friendly message or original error message if no match found
 */
const translateKnownErrors = (baseError?: string, code?: string): string => {
  if (!baseError) return '';

  const errorsMapping: Record<string, string> = {
    EFLD021:
      'Unable to archive field due to a crop zone in an active season(s) associated with this record',
    EEXT001: "You can't archive a field created on the same day"
  };

  if (code) {
    const matchedKey = Object.keys(errorsMapping).find(
      key => key.toLowerCase() === code.toLowerCase()
    );
    if (matchedKey) {
      return errorsMapping[matchedKey];
    }
  }

  return baseError;
};

export { translateKnownErrors };
